import DonutCard from '@dashboard/components/DonutCard'
import type { MethodByVolumeEntry } from '@dashboard/types/analytics.types'
import { buildTopNWithOther } from '@dashboard/utils/analyticsHelpers'
import { tr } from 'mmfintech-commons'

const METHOD_COLORS = [
  'var(--chart-series-1)',
  'var(--chart-series-2)',
  'var(--chart-series-3)',
  'var(--dash-text-faint)',
  'var(--dash-border-medium)'
]

interface Props {
  methods: MethodByVolumeEntry[]
  isLoading: boolean
}

function MethodsByVolumeCard({ methods, isLoading }: Props) {
  const segments = buildTopNWithOther(methods, 'methodName', METHOD_COLORS)

  return (
    <DonutCard isLoading={isLoading}>
      <DonutCard.Header
        title={tr('FRONTEND.DASHBOARD.METHODS_BY_VOLUME.TITLE', 'Methods by Volume')}
        subtitle={tr('FRONTEND.DASHBOARD.METHODS_BY_VOLUME.SUBTITLE', 'Payment method breakdown')}
      />
      <DonutCard.Body
        segments={segments}
        innerLabel={String(methods.length)}
        innerCaption={
          methods.length === 1
            ? tr('FRONTEND.DASHBOARD.METHODS_BY_VOLUME.METHOD_SHORT', 'method')
            : tr('FRONTEND.DASHBOARD.METHODS_BY_VOLUME.METHODS_SHORT', 'methods')
        }
        emptyMessage={tr('FRONTEND.DASHBOARD.NO_TRANSACTION_DATA', 'No transaction data available.')}
      />
    </DonutCard>
  )
}

export default MethodsByVolumeCard
